// 📚 Nom d'une matière dans la langue de l'interface : subject_name est le nom anglais
// (« Physics-Chemistry »), subject_name_fr le nom français (« Physique-Chimie ») ; sans nom
// français, le nom anglais.
const isEnglish = (language) => String(language || "fr").toLowerCase().startsWith("en");

// Matière peuplée par l'API (subject_expertise)
export const subjectName = (subject, language) =>
  (isEnglish(language) ? subject?.subject_name : subject?.subject_name_fr || subject?.subject_name) || "";

// Matière renvoyée à plat par l'API (subject : anglais, subject_fr : français)
export const subjectOfItem = (item, language) => (isEnglish(language) ? item?.subject : item?.subject_fr || item?.subject) || "";
